<script setup lang="ts">
// Types
import type { IMembershipSubscription } from "@citizenm/membership/shared/types/comparesubscriptions";

const { logo, description, features } = defineProps<IMembershipSubscription>();

const normalizeIconName = (name: string) => `foundation:${slugify(name)}`;
</script>

<template>
  <div class="membership-compare-subscription">
    <div class="membership-compare-subscription__logo-wrapper">
      <NuxtImg
        v-if="logo.fields.file?.url"
        :src="logo.fields.file?.url"
        :alt="logo.fields.title"
        provider="contentful"
      />
    </div>
    <div class="membership-compare-subscription__text">
      <ContentfulNodeRenderer
        v-if="description?.content"
        :nodes="description.content"
      />
    </div>
    <div
      v-if="Array.isArray(features) && features.length"
      class="membership-compare-subscription__features"
    >
      <FoundationList>
        <FoundationListItem
          v-for="(feature, index) in features"
          :key="index"
          bold
          :size="ELEMENT_SIZE.Large"
        >
          <template #start
            ><Icon :name="normalizeIconName(feature.icon)"
          /></template>
          {{ feature.label }}
        </FoundationListItem>
      </FoundationList>
    </div>
  </div>
</template>

<style scoped lang="scss">
.membership-compare-subscription {
  flex: 1 1 auto;
  color: inherit;
  container-type: inline-size;

  &__logo-wrapper {
    display: flex;
    align-items: center;
    height: 3.5rem;

    img {
      width: 75%;
      max-width: 15rem;

      @container (width > 25rem) {
        width: 50%;
      }
    }
  }

  &__features {
    margin-block-start: var(--spacing-6, 1.5rem);
  }

  &__text {
    @container (width > 25rem) {
      margin-block: var(--spacing-6, 1.5rem);
    }
  }

  @container (width > 25rem) {
    :deep(.foundation-list) {
      padding-left: var(--spacing-4, 1rem);
    }
  }
}
</style>
